<template>
  <div
    class="c-footer o-grid o-grid--direction-row o-grid--wrap-nowrap o-wrap--padding-side-default o-grid--justify-content-end o-grid--align-items-center"
  >
    <div class="o-grid__group">
      <div class="o-grid__item">
        <svg
          class="c-footer__logo o-svg-icon"
          viewBox="0 0 220 45"
          type="image/svg+xml"
        >
          <use
            xlink:href="spritemap.svg#sprite-logo-defaulthjeva"
            x="0"
            y="0"
          ></use>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "c-footer"
};
</script>
<style lang="scss">
.c-footer {
  background-color: $s-cp-neutral-white;
  min-height: toRem(120px);

  .o-svg-icon {
    fill: $s-cp-neutral-black;
  }

  &__logo {
    height: toRem(40px);
    fill: initial;
  }
  &__links {
    width: auto;
    height: 100%;
  }
  .o-grid__item {
    flex: 0 0 auto;
  }

  a {
    color: $s-cp-sup-red;
  }
}
</style>
